<template>
  <div>
    <Drawer title="订单详情" width="900" :value="showEdit" :mask-closable="true" @on-close="cancelEdit">
      <Row>
        <Col span="12" class="info-item">
          <span>订单ID:</span>
          <span>{{baseInfo.order_id}}</span>
        </Col>
        <Col span="12" class="info-item">
          <span>油站类型:</span>
          <span>{{baseInfo.type_name}}</span>
        </Col>
        <Col span="12" class="info-item">
          <span>用户ID:</span>
          <span>{{baseInfo.user_id}}</span>
        </Col>
        <Col span="12" class="info-item">
          <span>手机号:</span>
          <span>{{baseInfo.mobile}}</span>
        </Col>
        <Col span="12" class="info-item">
          <span>昵称:</span>
          <span>{{baseInfo.nick_name}}</span>
        </Col>
        <Col span="12" class="info-item">
          <span>油站名称:</span>
          <span>{{baseInfo.gas_name}}</span>
        </Col>
        <Col span="12" class="info-item">
          <span>油站地址:</span>
          <span>{{baseInfo.gas_address}}</span>
        </Col>
        <Col span="12" class="info-item">
          <span>油号:</span>
          <span>{{baseInfo.oil_no_name}}</span>
        </Col>
        <Col span="12" class="info-item">
          <span>枪号:</span>
          <span>{{baseInfo.gun_no}}</span>
        </Col>

        <!--<Col span="12" class="info-item" v-if="baseInfo.pay_info">
          <span>支付流水:</span>
          <span>{{baseInfo.pay_info.trade_no}}</span>
        </Col>-->
        <Col span="12" class="info-item">
          <span>下单时间:</span>
          <span>{{baseInfo.create_time}}</span>
        </Col>

        <Col span="12" class="info-item">
          <span>是否结账:</span>
          <span>{{baseInfo.is_settle > 0 ? '是' : '否'}}</span>
        </Col>

      </Row>

      <Card>
        <Row>
          <Col span="12" class="info-item">
            <span>购买总价:</span>
            <span>{{baseInfo.total_price}}</span>
          </Col>
          <Col span="12" class="info-item">
            <span>实付价格:</span>
            <span class="important-word">{{baseInfo.pay_price}}</span>
          </Col>
          <Col span="12" class="info-item">
            <span>平台收入:</span>
            <span class="important-word">{{baseInfo.plate_income}}</span>
          </Col>
          <Col span="12" class="info-item">
            <span>挂牌价:</span>
            <span>{{baseInfo.price_official}} 元/L</span>
          </Col>
          <Col span="12" class="info-item">
            <span>供应商价:</span>
            <span>{{baseInfo.gun_price}} 元/L</span>
          </Col>
          <Col span="12" class="info-item">
            <span>平台价:</span>
            <span>{{baseInfo.buy_price}} 元/L</span>
          </Col>
          <Col span="12" class="info-item">
            <span>升数:</span>
            <span>{{baseInfo.litre_num}}</span>
          </Col>
         <!-- <Col span="12" class="info-item">
            <span>优惠价格:</span>
            <span>{{baseInfo.total_discount_amount}} = {{baseInfo.discount_amount}} * {{baseInfo.litre_num}}升 </span>
          </Col>
          <Col span="12" class="info-item" v-if="baseInfo.total_member_discount>0">
            <span>会员优惠:</span>
            <span>{{baseInfo.total_member_discount}} = {{baseInfo.member_discount}} * {{baseInfo.litre_num}}升</span>
          </Col>
          <Col span="12" class="info-item">
            <span>用户返佣:</span>
            <span>{{baseInfo.buy_commission_amount}}</span>
          </Col>
          <Col span="12" class="info-item">
            <span>供应商返佣:</span>
            <span>{{baseInfo.sale_commission_amount}}</span>
          </Col>-->
        </Row>

      </Card>

      <Card title="价格调整" style="margin-top: 16px;">
        <Form :model="adjustForm" :label-width="100">
          <FormItem label="调整金额(元)">
            <InputNumber v-model="adjustForm.price_adjust" :precision="2" :step="0.01" placeholder="请输入调整金额" style="width: 200px;"></InputNumber>
          </FormItem>
          <FormItem label="调整说明">
            <Input v-model="adjustForm.remark" type="textarea" :rows="3" placeholder="请输入调整说明"></Input>
          </FormItem>
          <FormItem>
            <Button type="primary" @click="handleAdjust" :loading="adjustLoading">提交调整</Button>
            <Button @click="resetAdjust" style="margin-left: 8px;">重置</Button>
          </FormItem>
        </Form>
      </Card>

      <Card title="调整历史" style="margin-top: 16px;">
        <Table :columns="historyColumns" :data="adjustHistory" border></Table>
      </Card>

    </Drawer>
  </div>
</template>

<script>
  import pageTable from "@/components/table/pageTable";
  export default {
    name: "edit",
    components:{pageTable},
    props:{
      showEdit:{
        type:Boolean,
        default: false
      },
      order_id:{
        type:Number,
        default: 0
      }
    },
    data(){
      return {
        baseInfo:{},
        adjustForm: {
          price_adjust: 0,
          remark: ''
        },
        adjustLoading: false,
        adjustHistory: [],
        historyColumns: [
          {
            title: '调整ID',
            key: 'id',
            width: 100
          },
          {
            title: '调整金额',
            key: 'price_adjust',
            width: 120,
            render: (h, params) => {
              const value = params.row.price_adjust;
              const color = value >= 0 ? '#19be6b' : '#ed4014';
              return h('span', {
                style: { color: color, fontWeight: 'bold' }
              }, value > 0 ? `+${value}` : value);
            }
          },
          {
            title: '调整说明',
            key: 'remark',
            minWidth: 200
          },
          {
            title: '操作人',
            key: 'operator',
            width: 120
          },
          {
            title: '调整时间',
            key: 'create_time',
            width: 180
          }
        ]
      }
    },
    methods:{
      async getInfo(){
        let res = await this.$commonFun.postProxy('admin/order/getDetailInfo',{order_id:this.order_id});
        this.$commonFun.dealApiResult(res,()=>{
          this.baseInfo = res.data
          // 如果订单已支付,自动加载调整历史
          if (this.baseInfo.pay_status == 1 || this.baseInfo.is_pay == 1) {
            this.loadAdjustHistory();
          }
        })
      },
      cancelEdit(){
         this.$emit('cancel-edit')
      },
      reloadPage(user_id){
        this.$parent.reloadDetail(user_id)
      },
      // 加载调整历史
      async loadAdjustHistory(){
        let res = await this.$commonFun.postProxy('admin/order/getAdjustHistory',{order_id:this.order_id});
        this.$commonFun.dealApiResult(res,()=>{
          this.adjustHistory = res.data || [];
        });
      },
      // 执行价格调整
      async handleAdjust(){
        if (!this.adjustForm.remark) {
          this.$Message.warning('请填写调整说明');
          return;
        }
        this.adjustLoading = true;
        try {
          let res = await this.$commonFun.postProxy('admin/order/adjustPrice',{
            order_id: this.order_id,
            price_adjust: this.adjustForm.price_adjust,
            remark: this.adjustForm.remark
          });
          this.$commonFun.dealApiResult(res, async ()=>{
            this.$Message.success('价格调整成功');
            this.resetAdjust();
            // 重新加载订单信息和调整历史
            await this.getInfo();
            await this.loadAdjustHistory();
          });
        } catch (error) {
          this.$Message.error('价格调整失败');
        } finally {
          this.adjustLoading = false;
        }
      },
      // 重置表单
      resetAdjust(){
        this.adjustForm = {
          price_adjust: 0,
          remark: ''
        };
      }
    },
    mounted() {
        this.getInfo()
    },
    watch:{

    }
  }
</script>

<style scoped lang="less">
  .drawer-footer{
    width: 100%;
    position: absolute;
    bottom: 0;
    left: 0;
    border-top: 1px solid #e8e8e8;
    padding: 10px 16px;
    text-align: right;
    background: #fff;
  }

</style>
